import React from "react";
import { Router } from "react-router-dom";
import { render } from "react-dom";
import { Provider as ReduxProvider } from "react-redux";

import { history } from "./_helpers";
import { App } from "./app";
import configureStore from "./_redux/configureStore";
import { registerLicense } from "@syncfusion/ej2-base";

import "./i18n";
import "./styles.css";
import "./syncF.modules.css";

registerLicense(
  "ORg4AjUWIQA/Gnt2UVhhQlVFfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5QdkNiXXxfcnVUQmhc;Mgo+DSMBMAY9C3t2UVhhQlVFfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5QdkNiXXxfcnVUQGNa"
);

const store = configureStore();

render(
  <ReduxProvider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </ReduxProvider>,
  document.getElementById("app")
);
